import { render } from "./LightRow.vue?vue&type=template&id=197b2993&scoped=true"
import script from "./LightRow.vue?vue&type=script&lang=js"
export * from "./LightRow.vue?vue&type=script&lang=js"

import "./LightRow.vue?vue&type=style&index=0&id=197b2993&scoped=true&lang=css"

import exportComponent from "C:\\Data\\lightsOut\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-197b2993"]])

export default __exports__